<template lang="html">
  <canvas class="compass-gauge"></canvas>
</template>

<script>
import { RadialGauge } from 'canvas-gauges'

export default {
  name: 'compass-gauge',
  props: {
    value: {
      type: Number,
      required: true
    }
  },
  data: function () {
    return {
      chart: {},
      options: {
        width: 250,
        height: 250,
        title: 'Acimut',
        minValue: 0,
        maxValue: 360,
        majorTicks: [
          'N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW', 'N'
        ],
        minorTicks: 22,
        ticksAngle: 360,
        startAngle: 180,
        strokeTicks: false,
        highlights: false,
        colorPlate: '#222',
        colorMajorTicks: '#f5f5f5',
        colorMinorTicks: '#ddd',
        colorTitle: '#fff',
        colorNumbers: '#eee',
        colorNeedle: 'rgba(240, 128, 128, 1)',
        colorNeedleEnd: 'rgba(255, 160, 122, .9)',
        valueBox: false,
        valueTextShadow: false,
        colorCircleInner: '#fff',
        colorNeedleCircleOuter: '#ccc',
        needleCircleSize: 15,
        needleCircleOuter: false,
        animationRule: 'linear',
        needleType: 'line',
        needleStart: 75,
        needleEnd: 99,
        needleWidth: 3,
        borders: true,
        borderInnerWidth: 0,
        borderMiddleWidth: 0,
        borderOuterWidth: 10,
        colorBorderOuter: '#ccc',
        colorBorderOuterEnd: '#ccc',
        colorNeedleShadowDown: '#222',
        borderShadowWidth: 0,
        animationDuration: 1500
      }
    }
  },
  watch: {
    value: function (curse) {
      this.chart.value = curse
    }
  },
  mounted () {
    this.options.value = this.value
    this.options.renderTo = this.$el
    this.chart = new RadialGauge(this.options).draw()
  },
  beforeDestroy () {
    this.chart.destroy()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Gauges/Compass.vue